import { Component, ErrorHandler, Input, ViewChild, inject } from '@angular/core';
import { saveAs } from 'file-saver';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioAssignment } from 'src/modules/enaio/shared/EnaioAssignment';
import { EnaioDocument } from 'src/modules/enaio/shared/EnaioDocument';
import { EnaioObjectId } from 'src/modules/enaio/shared/EnaioObjectId';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldListItem } from 'src/modules/sm-base/models/frontend-field-list-item.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { FileUploadService } from 'src/modules/sm-base/services/file-upload-service';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { OrdinaryObject } from 'src/modules/utils/shared/ordinary-object.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { EnaioDocumentsModule } from '../../enaio-documents.module';
import { EnaioDocumentFrontendResult } from '../../models/enaio-document-frontend-result.model';
import { EnaioFrontendInsertData } from '../../models/enaio-frontend-insert-data';
import { TableCellButton } from 'src/modules/sm-base/models/table-cell-button.model';
import { TableCellEvent } from 'src/modules/sm-base/models/table-cell-event.model';
import { SmTable2Component } from 'src/modules/sm-base/components/sm-table2/sm-table2.component';
import { MenuItem } from 'primeng/api';
import { EnaioDocumentResult } from '../../models/enaio-document-result.model';

@Component({
    selector: 'app-enaio-documents-definition',
    templateUrl: './enaio-documents-definition.component.html',
    styleUrls: ['./enaio-documents-definition.component.scss']
})
export class EnaioDocumentsDefinitionComponent extends ComponentView {

    fileUpload = inject(FileUploadService);

    neededParams: ObjectOfSimpleDataTypes = { defId: "string", parentId: "number?", anonymousGuid: "string?" };
    @Input()
    defId = "";
    @Input()
    parentId = 0;
    @Input()
    queryOptions: OrdinaryObject = null;

    def: EnaioDocumentFrontendResult = null;
    searchFields: FrontendFieldDefinition[] = [];
    anonymousGuid: string;
    selectedDocument: EnaioDocumentResult = null;
    selectedDocuments: EnaioDocumentResult[] = [];
    selectedRemarkObject: EnaioDocumentResult = null;

    uploadedFileContents: ArrayBuffer;
    displayModal: boolean;
    modalForm: FrontendFormDefinition = null;
    allRows: TableRow[];
    table: TableData;
    fullTextSearchTerm = "";
    selection: any;
    displaySeen = false;
    itemOpened = false;

    remarkObjects: FrontendFieldListItem[] = null;
    
    exportMenuItems: MenuItem[] = [];

    input = "";

    @ViewChild("tDocuments")
    tDocuments: SmTable2Component

    async initParams(): Promise<boolean> {
        this.init();
        await this.reload();
        return true;
    }

    init(): void {
        this.parentId ||= 0;

        this.exportMenuItems = [
            {
                label: this.app.t("documents.exportAsCsv") ,
                command: this.exportCsv.bind(this)
            },
            {
                label: this.app.t("documents.exportAsExcel") ,
                command: this.exportXlsx.bind(this)
            }
        ];
    }

    async reload(updateResult?: (result: EnaioDocumentFrontendResult) => void): Promise<void> {
        if (this.isAnonymous()) {
            this.def = await RestEndpoint.main().query({ anonymousGuid: this.anonymousGuid }).run("api/doc/def/anonymousresults").get(EnaioDocumentFrontendResult);
        }
        else {
            this.def = Utils.arraySortBy(await RestEndpoint.main().query({ includeResultCounts: false }).run("api/doc/def").list(EnaioDocumentFrontendResult), def => def.name)[0];
            this.searchFields = (this.def.searchFields ?? []).map(sf => new FrontendFieldDefinition(sf.id, sf.title, FrontendFieldType.fromGenericDataType(sf.type), { value: sf.getDefaultValueForForm()}));
            this.def = await RestEndpoint.main().query(Utils.objectRemoveNullValues({ defId: this.defId, parentId: this.parentId,
                queryOptions: this.queryOptions != null ? Utils.toJson(this.queryOptions) : Utils.toJson(this.getQueryOptions()) })).run("api/doc/def/search").get(EnaioDocumentFrontendResult);
        }
        this.def.translate(this.app);

        if (updateResult != null) {
            updateResult(this.def);
        }

        this.defId = this.def.defId; //Überschreiben, weil bei AnonymousSearch die defID vorher nicht zwingend feststeht

        this.updateTable();

     /*   if (!this.app.isMobile() && this.allRows.length > 1) {
            this.selection = this.allRows[0];
            this.rowSelect(this.selection);
        }
        else {
       */     this.rowSelect(null);
       // }

        if (!this.embeddedComponent) {
            this.app.updateNavigation(this.app.t("documents.title") + " - " + this.def.name, this.isAnonymous() ? [] : [
                EnaioDocumentsModule.mainBreadcrumb,
                //   this.result.parentName !== "" ? { label: this.result.parentName, routerLink: ["/enaio-documents/definition", this.result.defId, 0] } : null,
                { label: this.def.name, routerLink: ["/enaio-documents/definition", this.def.defId, this.def.parentId]}
            ]);
        }
        //}
    }

    updateTable(): void {
        this.table = new TableData(this.def.columns.map(col => new TableColumn(col.title, col.title, col.toTableCellType(), {  flex: 1 })),
            this.def.documents.map(doc => new TableRow("", doc, {_objectType: doc.doc.objectType.name, ...Utils.arrayConvertToOrdinaryObject(this.def.columns, col => col.title, col => doc.columns[col.title])})), 
            this.def.sortColumns?.map(col => new TableSortColumn(col.title, col.ascending)));

        if (this.def.childDefId !== "") {
            this.table.columns = Utils.arrayWithoutNull([
                new TableColumn("_open", "", TableCellType.button, { sortable: false, filterable: false }),
                this.def.displayObjectTypeColumn ? new TableColumn("_objectType", "Objekttyp") : null,
                ...this.table.columns
            ]);
            for (let row of this.table.rows) {
                row.values._open = [new TableCellButton("open", "fas fa-search", "Öffnen")];
            }
        }

        if (this.def.hasDocuments) {
            this.table.columns = Utils.arrayWithoutNull([
                new TableColumn("_download", "", TableCellType.button, { autoWidth: 1, sortable: false, filterable: false }),
                this.def.displayObjectTypeColumn ? new TableColumn("_objectType", this.app.t("enaio.objectType")) : null,
                ...this.table.columns
            ]);
            for (let row of this.table.rows) {
                row.values._download = [new TableCellButton("download", "fas fa-download", "Herunterladen")];
            }
        }

        if (this.def.useSeenMarker) {
            this.table.columns = [
                new TableColumn("_seen", "", TableCellType.yesNo, { autoWidth: 1, sortable: false, filterable: false, editable: true, icon: "fas fa-eye" }),
                ...this.table.columns
            ];
            for (let row of this.table.rows) {
                row.values._seen = (row.raw as EnaioDocument).getBoolByInternal("__portalDocumentSeen");
            }
        }

        this.allRows = this.table.rows;
        this.updateFilter();
    }

    isAnonymous(): boolean {
        return !Utils.isNoe(this.anonymousGuid);
    }

    formValueToQueryValue(o: any): any {
        return o instanceof Date ? Utils.dateFormatDefaultDate(o) : onanimationend;
    }

    getQueryOptions(): OrdinaryObject {
        return Utils.arrayConvertToOrdinaryObject(this.searchFields, sf => sf.id, sf => this.formValueToQueryValue(sf.getValue()));
    }

    async searchDocuments(): Promise<void> {
        let searchResult = await RestEndpoint.main().query({ defId: this.defId, parentId: this.parentId, queryOptions: Utils.toJson(this.getQueryOptions()), quickSearch: this.input }).run("api/doc/def/search").get(EnaioDocumentFrontendResult);

        if (this.def.useSearchBar) {
            if (searchResult.documents.length == 0) {
                this.app.showToast("info", this.app.t("documents.notFound_title"), this.app.t("documents.notFound", { name: searchResult.nameSingular }));
                return;
            }
            if (searchResult.documents.length > 1) {
                this.app.showToast("info", this.app.t("documents.foundMultiple_title"), this.app.t("documents.foundMultiple", { name: searchResult.name }));
                return;
            }

            await this.app.navigateTo(["/enaio-documents", "definition", this.def.childDefId, searchResult.documents[0].doc.id]);
        }
        else {
            this.def = searchResult;
            this.updateTable();
        }
    }

    async newDocument(_): Promise<void> {
        this.uploadedFileContents = (await this.fileUpload.chooseFile())[0].contents;

        this.displayModal = true;
        this.modalForm = new FrontendFormDefinition([
            new FrontendFieldDefinition("title", "Titel", FrontendFieldType.text),
            new FrontendFieldDefinition("document_number", "DokumentNr", FrontendFieldType.text),
            new FrontendFieldDefinition("doc_type", "Dokumenttyp", FrontendFieldType.comboBox)
        ]);

        this.modalForm.getField("doc_type").listItems = [
            new FrontendFieldListItem("Allgemeine Beschreibung", "Allgemeine Beschreibung"),
            new FrontendFieldListItem("Verfahrensanweisung", "Verfahrensanweisung"),
            new FrontendFieldListItem("Arbeitsanweisung", "Arbeitsanweisung"),
            new FrontendFieldListItem("Formular", "Formular"),
            new FrontendFieldListItem("Checkliste", "Checkliste"),
            new FrontendFieldListItem("Ausgabe an Kunden", "Ausgabe an Kunden"),
            new FrontendFieldListItem("Weitere Unterlagen", "Weitere Unterlagen"),
            new FrontendFieldListItem("Anforderungen", "Anforderungen"),
            new FrontendFieldListItem("Betriebsanweisung", "Betriebsanweisung"),
            new FrontendFieldListItem("Sicherheitsdatenblatt", "Sicherheitsdatenblatt"),
            new FrontendFieldListItem("Aushang", "Aushang"),
            new FrontendFieldListItem("Organigramm", "Organigramm"),
            new FrontendFieldListItem("Stellenbeschreibung", "Stellenbeschreibung"),
            new FrontendFieldListItem("gemeinsame Verantwortung", "gemeinsame Verantwortung"),
            new FrontendFieldListItem("ADV", "ADV"),
            new FrontendFieldListItem("TOM", "TOM"),
            new FrontendFieldListItem("DSFA", "DSFA")
        ];
    }

    async insertDocument(): Promise<void> {
        let insert = new EnaioFrontendInsertData();
        insert.defId = this.def.defId;
        insert.parentId = this.parentId;
        insert.fields = [];
        for (let field of this.modalForm.fields) {
            insert.fields.push(new EnaioAssignment(EnaioObjectId.byInternalName(field.id), field.value));
        }
        insert.documentBase64 = Utils.bytesToBase64(this.uploadedFileContents);
        insert.documentFileName = "document.pdf";
        await RestEndpoint.main().post().body(insert).run("api/doc/def/document").getText();
        this.displayModal = false;
        await this.reload();
    }

    x = "<span class=\"p-badge\">1</span>'"
    rowSelect(event): void {
        this.selectedDocument = event?.raw;
        if (this.selectedDocument != null) {
            this.itemOpened = true;
            this.remarkObjects = (this.selectedDocument.remarkObjects ?? []).map(doc => {
                var doc2 = Utils.fromPlain(EnaioDocumentResult, doc);
                var name = doc2.doc.objectType?.getBestDisplayName();
                var add = "";
                //PRAGMATIC (zukünftig konfigurierbar)
                if (name == "Reisekostenbeleg") {
                    let note = doc2.doc.getStringByInternal("Bemerkung");
                    add = " - " + doc2.doc.getStringByInternal("Typ") + (Utils.isNoe(note) ? "" : " - " + note);  
                }
                return new FrontendFieldListItem(doc, Utils.toString((name ?? "???") + add));
            }); 
            if (Utils.isNoe(this.remarkObjects)) {
                this.remarkObjects = null;
                this.selectedRemarkObject = null;
            }
            else {
                this.remarkObjects = [new FrontendFieldListItem(this.selectedDocument, "Hauptdokument"), ...this.remarkObjects];
                this.selectedRemarkObject = this.selectedDocument;
            }
        }
        else {
            this.remarkObjects = null;
            this.selectedRemarkObject = null;
        }
    }

    async cellClicked(event: TableCellEvent): Promise<void> {
        if (event.isButton("open", "_open")) {
            await this.open((event.row.raw as EnaioDocumentResult).doc.id);
        }
        else if (event.isButton("download", "_download")) {
            await this.downloadDocument((event.row.raw as EnaioDocumentResult).token);
        }
    }

    async markAllAsSeen(): Promise<void> {
        let ids: number[] = [];
        for (let row of this.table.rows) {
            if (!row.values._seen) {
                row.values._seen = true;
                (row.raw as EnaioDocument).getFieldByInternalName("__portalDocumentSeen").value = true;
                ids = [...ids, (row.raw as EnaioDocument).id];
            }
        }
        if (ids.length > 0) {
            await RestEndpoint.main().post().query({ objectIds: Utils.arrayItemsToString(ids, ","), seen: true }).run("api/doc/def/markSeen").getText();
            this.updateFilter();
        }
    }

    async cellEdited(event: TableCellEvent): Promise<void> {
        if (event.column.colId == "_seen") {
            let doc = event.row.raw as EnaioDocument;
            doc.getFieldByInternalName("__portalDocumentSeen").value = event.row.values._seen;
            await RestEndpoint.main().post().query({ objectIds: doc.id, seen: event.row.values._seen ? 1 : 0 }).run("api/doc/def/markSeen").getText();
            this.updateFilter();
        }
    }

    async open(id: number): Promise<void> {
        await this.app.navigateTo(["/enaio-documents", "definition", this.def.childDefId, Utils.toString(id)]);
    }

    async downloadDocument(token: string): Promise<void> {
        let doc = this.def.documents.find(d => d.token == token);
        let result = (await this.app.genericDataHandler(async () => await RestEndpoint.main().query({token, convert: 0}).runBlob("api/doc/document/document"), null, "toast"));
        if (result.ok) {
            saveAs(result.value, doc.doc.metaData[0].value + ".pdf");
        }        
    }

    async downloadAll(): Promise<void> {
        if (this.isAnonymous()) {
            saveAs(await RestEndpoint.main().post().query({anonymousGuid: this.anonymousGuid}).body(this.table.rows.map(row => (row.raw as EnaioDocument).id)).runBlob("api/doc/def/anonymousgetMulti"), "Dokumente.zip");
        }
        else {
            saveAs(await RestEndpoint.main().post().body(this.def.documents.map(doc => doc.doc.id)).runBlob("api/doc/document/getMulti"), "Dokumente.zip");
        }
    }

    async filterChanged(): Promise<void> {
        await this.searchDocuments();
    }

    updateFilter(): void {
        let useFilter = !Utils.isNoe(this.fullTextSearchTerm);
        this.table.rows = this.allRows.filter(row =>
            (!this.def.useSeenMarker || this.displaySeen || !(row.raw as EnaioDocument).getBoolByInternal("__portalDocumentSeen")) &&
            (!useFilter || Utils.objectGetValues(row.values).find(value => Utils.matchesFullTextQuery(Utils.toString(value) ?? "", this.fullTextSearchTerm))));
        if (this.selectedDocument != null && !this.table.rows.some(row => (row.raw as EnaioDocument).id == this.selectedDocument.doc.id)) {
            this.selectedDocument = null;
        }
    }

    closeItemWindow(visible: boolean): void {
        if (!visible) {
            this.itemOpened = false;
        }
    }

    exportCsv(): void {
        this.tDocuments.exportCsv();
    }

    exportXlsx(): void {
        this.tDocuments.exportXlsx();
    }

}
